import { render, staticRenderFns } from "./SearchResultTokenTable.vue?vue&type=template&id=fab6ee82&scoped=true"
import script from "./SearchResultTokenTable.vue?vue&type=script&lang=js"
export * from "./SearchResultTokenTable.vue?vue&type=script&lang=js"
import style0 from "./SearchResultTokenTable.vue?vue&type=style&index=0&id=fab6ee82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab6ee82",
  null
  
)

export default component.exports